package it.unibo.tuprolog.ui.gui.presentation

/** How serious a [Diagnostic] is. */
enum class DiagnosticSeverity {
    INFO,
    WARNING,
    ERROR,
}
